/* eslint-disable max-len */
import { template_translation } from '../lang/TemplateTranslation';
const t = template_translation;

/** 5.変数でサイズを決める */
export const template5 = {
  title: t.to('サイズを決めるために変数を使う', 'title5'),
  desc: t.to(
    '「変数」は値を覚えておくことができるものです。変数を使うには項目の書き始めを「',
    'desc5'
  ),
  img: '../public/template/5.png',
  xml: `
  <xml xmlns="http://www.w3.org/1999/xhtml">
  <variables>
  </variables>
  <block type="a-scene-start" x="110" y="190">
    <field name="is_init">off</field>
    <field name="hasController">on</field>
    <statement name="IN">
      <block type="logic_set_value_v2">
        <field name="VAR_NAME">x</field>
        <field name="VALUE">4</field>
        <next>
          <block type="cube_v2">
            <field name="id">block1</field>
            <field name="position-x">= x</field>
            <field name="position-y">0</field>
            <field name="position-z">-4</field>
            <value name="COLOUR">
              <shadow type="color_value_v2">
                <field name="COLOUR">#d163d8</field>
              </shadow>
            </value>
            <value name="ATTR">
              <block type="scale_v2">
                <field name="scale-x">=x</field>
                <field name="scale-y">=x</field>
                <field name="scale-z">=x</field>
              </block>
            </value>
            <next>
              <block type="a-text_v2">
                <field name="text">= "X = " + x</field>
                <field name="id">block2</field>
                <field name="position-x">0</field>
                <field name="position-y">4</field>
                <field name="position-z">0</field>
                <value name="COLOUR">
                  <shadow type="color_value_v2">
                    <field name="COLOUR">#28fdb2</field>
                  </shadow>
                </value>
              </block>
            </next>
          </block>
        </next>
      </block>
    </statement>
  </block>
</xml>
`,
};
